module.exports = __webpack_public_path__ + "img/cardnet.de2475e8.png";